import { baseURL, ERR_OK } from './config'
import axios from 'axios'

// 获取天气实况

export function getWeatherCurrent (locationKey, requestDate) {
  return axios.get(`${baseURL}/weather/currentConditions?mddid=${locationKey}`).then((res) => {
    if (res && res.data.http_code === ERR_OK) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error('current'))
    }
  })
}

// 获取天气预警

export function getWeatherAlerts (locationKey) {
  return axios.get(`${baseURL}/weather/alarms15Day?mddid=${locationKey}`).then((res) => {
    if (res && res.data.http_code === ERR_OK) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error('alerts'))
    }
  })
}

// 获取天气指数

export function getWeatherIndices (locationKey) {
  return axios.get(`${baseURL}/weather/indicesDaily?mddid=${locationKey}&day_num=1`).then((res) => {
    if (res && res.data.http_code === ERR_OK) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error('indices'))
    }
  })
}

// 获取逐小时

export function getWeatherHourly (locationKey) {
  return axios.get(`${baseURL}/weather/forecastsHourly?mddid=${locationKey}&hour_num=24`).then((res) => {
    if (res && res.data.http_code === ERR_OK) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error('hour'))
    }
  })
}

// 获取十五天预报

export function getWeather15day (locationKey) {
  return axios.get(`${baseURL}/weather/forecastsDaily?mddid=${locationKey}&day_num=15`).then((res) => {
    if (res && res.data.http_code === ERR_OK) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error('15day'))
    }
  })
}

export function getMddInfo (locationKey) {
  return axios.get(`${baseURL}/mdd/info/${locationKey}`).then((res) => {
    if (res) {
      return Promise.resolve(res.data)
    } else {
      return Promise.reject(new Error('mdd'))
    }
  })
}

export function getMddList (name) {
  return axios.get(`/mddSearch?name=${name}`).then((res) => {
    if (res) {
      return Promise.resolve(res.data)
    } else {
      return Promise.reject(new Error('mddList'))
    }
  })
}
